import 'promise-polyfill/src/polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import getCurrentScriptPath from '@homeaway/current-script-path';

import {ClientApp} from './components/App/ClientApp';

// @ts-ignore Ignoring
if (!module.hot) {
    // @ts-ignore Ignoring
    __webpack_public_path__ = getCurrentScriptPath(); // eslint-disable-line
}

// @ts-ignore React 16 hydrate method exists but types are for React 19
ReactDOM.hydrate(<ClientApp />, document.getElementById('root'));
